import {createClient} from 'contentful'

const client = createClient({
  space: '3qiijtzw6nyt',
  accessToken: 'vALkL3L8JVEabeR-08w3m4mCHPQdj9uADZGnmNOeZSQ'
})
  

export default client